/** @typedef {'bespoke' | 'foundation' | 'certified' | 'global'} WizardOutcomeId */

/**
 * @param {{ q1a?: number, q1b?: number, q1c?: number }} answers
 * @returns {WizardOutcomeId | 'path2' | null}
 */
export function scorePath1(answers) {
  const vals = [answers.q1a, answers.q1b, answers.q1c];
  if (vals.some((v) => v == null)) return null;
  if (vals.some((v) => v === 1)) return 'bespoke';
  if (vals.filter((v) => v === 3).length >= 2) return 'path2';
  if (vals.every((v) => v === 2)) return 'foundation';
  return 'foundation';
}

/**
 * @param {{ q2a?: number, q2b?: number, q2c?: number }} answers
 * @returns {WizardOutcomeId | null}
 */
export function scorePath2(answers) {
  const vals = [answers.q2a, answers.q2b, answers.q2c];
  if (vals.some((v) => v == null)) return null;
  if (vals.some((v) => v === 1)) return 'certified';
  return 'global';
}

/** Maps wizard outcome to Register.js `accreditationLevel` (global tier = `accredited`). */
export function outcomeToRegisterLevel(outcomeId) {
  if (outcomeId === 'foundation') return 'foundation';
  if (outcomeId === 'certified') return 'certified';
  if (outcomeId === 'global') return 'accredited';
  return null;
}
